import moment from "moment";
import { DateTimeProvider } from "./DateTimeProvider";


export class DispatchTimeCalculator
{
    public static Calc(deliverAt: Date, threshold = 4): Date
    {
        let whenSend = moment(deliverAt);

        while (threshold > 0)
        {
            const dayOfWeek = whenSend.day();

            // Is weekend - Saturday or Sunday
            if ([6, 0].includes(dayOfWeek)) // 6 is Saturday, 0 is Sunday
            {
                whenSend.subtract(1, 'day');
            }

            whenSend.subtract(1, 'day');

            threshold -= 1;
        }

        return whenSend.hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
    }

    public static GetDispatchTime(rentStart: Date, threshold = 4): Date
    {
        let whenSend = moment(DispatchTimeCalculator.Calc(rentStart, threshold));

        const today = moment(DateTimeProvider.Now).hour(0).minutes(0).seconds(0).milliseconds(0);

        if (whenSend.isBefore(today))
            whenSend = today;

        return whenSend.toDate();
    }
}
